import { Component } from '@angular/core';
import { Usuario } from '../../entities/usuario';
import { NavParams } from 'ionic-angular';

@Component({
    selector: 'home-page',
    templateUrl: './home.html'
})
export class HomePage {
    public usuario: Usuario;

    constructor(_navParams: NavParams) {
        this.usuario = _navParams.get('usuario');
    }


}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts